import { render, staticRenderFns } from "./PaymentRegistryListToolbar.vue?vue&type=template&id=48fba1dc&"
import script from "./PaymentRegistryListToolbar.vue?vue&type=script&lang=js&"
export * from "./PaymentRegistryListToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports